<template>
  <Teleport to="body">
    <div 
      class="notification-container position-fixed"
      style="top: 20px; right: 20px; z-index: 9999; max-width: 400px;"
    >
      <TransitionGroup 
        name="notification" 
        tag="div"
      >
        <div
          v-for="notification in notifications"
          :key="notification.id"
          :class="[
            'notification-item',
            'alert',
            `alert-${notification.type}`,
            'alert-dismissible',
            'mb-2',
            'shadow-sm'
          ]"
          style="width: 100%;"
        >
          <div class="d-flex align-items-start">
            <div class="flex-grow-1">
              <h6 v-if="notification.title" class="alert-heading mb-1">
                {{ notification.title }}
              </h6>
              <div v-if="notification.message" class="notification-message">
                {{ notification.message }}
              </div>
            </div>
            <button
              v-if="notification.closable"
              type="button"
              class="btn-close ms-2"
              @click="removeNotification(notification.id)"
              aria-label="Close"
            ></button>
          </div>
          
          <!-- Progress bar for auto-dismiss -->
          <div
            v-if="notification.duration > 0"
            class="notification-progress"
            :style="{
              animationDuration: `${notification.duration}ms`
            }"
          ></div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useNotifications } from '@/composables/useNotifications'

const { notifications, removeNotification } = useNotifications()
</script>

<style scoped>
.notification-container {
  pointer-events: none;
}

.notification-item {
  pointer-events: auto;
  position: relative;
  overflow: hidden;
  border-left-width: 4px;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.95);
}

.notification-message {
  font-size: 0.875rem;
  line-height: 1.4;
  word-wrap: break-word;
}

.notification-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: linear-gradient(90deg, currentColor 0%, transparent 100%);
  animation: notification-progress linear forwards;
  opacity: 0.7;
}

@keyframes notification-progress {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}

/* Transition animations */
.notification-enter-active {
  transition: all 0.3s ease-out;
}

.notification-leave-active {
  transition: all 0.3s ease-in;
}

.notification-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.notification-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.notification-move {
  transition: transform 0.3s ease;
}

/* Bootstrap alert customizations */
.alert-success {
  border-left-color: #198754;
}

.alert-danger {
  border-left-color: #dc3545;
}

.alert-warning {
  border-left-color: #fd7e14;
}

.alert-info {
  border-left-color: #0dcaf0;
}
</style>